
const digest = '0c8b29336e7046720e4d1d5e2a9f536599725faadd050e7ba05ac10e01302b42';
const classes = {"upload":"_upload_1lkl0_1","file":"_file_1lkl0_10","title":"_title_1lkl0_17","name":"_name_1lkl0_22","buttonTextWrapper":"_buttonTextWrapper_1lkl0_32","hint":"_hint_1lkl0_38","buttonWrapper":"_buttonWrapper_1lkl0_46","inputWrapper":"_inputWrapper_1lkl0_54"};
const css = `._upload_1lkl0_1 {
  background-color: #f2f4f7;
  padding: 36px 24px;
  margin: -34px -24px 24px -24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
._upload_1lkl0_1 ._file_1lkl0_10 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
}
._upload_1lkl0_1 ._file_1lkl0_10 ._title_1lkl0_17 {
  font-size: 16px;
  font-weight: 400;
  color: #000000;
}
._upload_1lkl0_1 ._file_1lkl0_10 ._name_1lkl0_22 {
  font-size: 18px;
  font-weight: 600;
  color: #000000;
  background-image: url("/dist/icons/delete-icon.svg");
  background-repeat: no-repeat;
  padding-right: 20px;
  background-position: center right;
  word-break: break-word;
}
._upload_1lkl0_1 ._buttonTextWrapper_1lkl0_32 {
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}
._upload_1lkl0_1 ._buttonTextWrapper_1lkl0_32 ._hint_1lkl0_38 {
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  flex-grow: 1;
  text-align: left;
  padding: 0 24px;
}
._upload_1lkl0_1 ._buttonWrapper_1lkl0_46 {
  gap: 5px;
  min-width: fit-content;
  height: fit-content;
  display: flex;
  flex-direction: column;
}

._inputWrapper_1lkl0_54 {
  display: none;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  